import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/src/all";

const useStaticHeadlineAnimations = (root: React.MutableRefObject<null>) => {
    const componentSelector = gsap.utils.selector(root);
    gsap.defaults({ ease: "power2.inOut", duration: 0.66 });

    useEffect(() => {
        gsap.set(
            [componentSelector("#heading"), componentSelector("#message")],
            { opacity: 0, y: "35px" }
        );

        ScrollTrigger.create({
            trigger: root.current,
            endTrigger: root.current,
            start: "top 70%",
            end: "top 70%",
            once: true,
            onEnter: () => {
                gsap.to(
                    [
                        componentSelector("#heading"),
                        componentSelector("#message"),
                    ],
                    { opacity: 1, y: "0px", stagger: 0.15 }
                );
            },
        });
    }, []);
};

export default useStaticHeadlineAnimations;
